import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addItem, increaseItemQuantity } from "../../../store/pos/posSlice";
import { RootState } from "../../../store/store";
import { getCurrencySymbol } from "../../../utils/currency/currencyUtils";
import { getMediaUrl } from "../../../utils/mediaUrl";

function Item({ item }: any) {
  const dispatch = useDispatch();
  const currencySymbol = getCurrencySymbol();
  const { addedItemArray } = useSelector(
    (state: RootState) => state.pos.current,
  );

  const inCart = addedItemArray.find((i: any) => i.itemId === item.id);
  const qtyInCart = inCart?.quantity || 0;

  const handleClick = () => {
    const existingItem = addedItemArray.find((i: any) => i.itemId === item.id);
    if (existingItem) {
      dispatch(increaseItemQuantity({ itemId: item.id, existingItem }));
    } else {
      dispatch(addItem(item));
    }
  };

  const stockDisplay =
    item.modified !== true
      ? item?.scale &&
        typeof item.scale === "string" &&
        item.scale.toLowerCase() !== "unit"
        ? `${item?.stock ?? ""}${item.scale}`
        : item?.stock
      : null;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={[
        "relative flex aspect-[4/5] w-full flex-col overflow-hidden rounded-lg border bg-white text-left transition-all duration-150",
        "hover:-translate-y-0.5 hover:border-erp-accent hover:shadow-[0_8px_18px_rgba(11,28,44,0.12)]",
        "active:translate-y-0 active:scale-[0.98]",
        qtyInCart > 0
          ? "border-erp-accent ring-2 ring-erp-accent/25"
          : "border-erp-line",
      ].join(" ")}
    >
      {stockDisplay !== null && stockDisplay !== undefined ? (
        <span className="absolute left-1.5 top-1.5 z-[1] rounded-md bg-erp-navy/85 px-1.5 py-0.5 text-[10px] font-semibold tabular-nums text-white">
          {stockDisplay}
        </span>
      ) : null}

      {qtyInCart > 0 ? (
        <span className="absolute right-1.5 top-1.5 z-[1] inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-erp-gold px-1 text-[10px] font-bold text-erp-navy">
          {qtyInCart}
        </span>
      ) : null}

      <div className="flex h-[55%] items-center justify-center bg-[#f4f7fa]">
        {item?.image ? (
          <img
            src={getMediaUrl(item?.image)}
            alt={item?.name || "item"}
            className="h-full w-full object-cover"
          />
        ) : (
          <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-[#8ea3b8]">
            No image
          </span>
        )}
      </div>

      <div className="flex min-h-0 flex-1 flex-col justify-between gap-1 p-2">
        <div className="min-h-0">
          <p
            className="m-0 line-clamp-2 text-[11px] font-semibold uppercase leading-tight text-erp-ink"
            title={item?.name}
          >
            {item?.name}
          </p>
          {item?.itemNumber ? (
            <p
              className={[
                "m-0 mt-0.5 truncate font-medium tabular-nums text-[#8ea3b8]",
                item.itemNumber.length > 9 ? "text-[10px]" : "text-[11px]",
              ].join(" ")}
            >
              {item.itemNumber}
            </p>
          ) : null}
        </div>
        <p className="m-0 text-[13px] font-bold tabular-nums text-erp-accent">
          {currencySymbol} {item?.price}
        </p>
      </div>
    </button>
  );
}

export default Item;
